import $ from 'jquery';

function handleScrollableText(container) {
    const scrollableTextContent = container.find('.scrollable-text-content');
    const shadow = container.find('.scrollable-text-shadow');
    const contentHeight = scrollableTextContent[0].scrollHeight;
    const containerHeight = scrollableTextContent.height();

    function updateShadowVisibility() {
        const scrollTop = scrollableTextContent.scrollTop();
        const shouldHide = scrollTop + containerHeight >= contentHeight;
        shadow.toggle(shouldHide).animate({ opacity: shouldHide ? 0 : 1 }, 500);
    }

    if (contentHeight <= containerHeight) {
        shadow.hide();
    } else {
        scrollableTextContent.on('scroll', updateShadowVisibility);
    }
}

$(function () {
    const scrollableTextContainers = $('.scrollable-text');

    scrollableTextContainers.each(function () {
        handleScrollableText($(this));
    });
});
